var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.$root.larkinContact.url}},[_vm._v(_vm._s(_vm.$root.larkinContact.phone))])
}
var staticRenderFns = []

export { render, staticRenderFns }